import { FC, useCallback, useRef } from 'react';
import { Box, Button, Text } from '@mantine/core';
import Plyr from 'plyr-react';
import type { APITypes } from 'plyr-react';
import styles from './Onboarding.module.css';
import { VIDEO_OPTIONS, VIDEO_SOURCE } from './Onboarding.const';
import 'plyr-react/plyr.css';

type OnboardingProps = {
    handleNext: () => void;
};
const Onboarding: FC<OnboardingProps> = ({ handleNext }) => {
    const isPlayed = useRef<boolean>(false);
    const handleAutoPlay = useCallback((player: APITypes | null) => {
        if (isPlayed.current || !player?.plyr.source) {
            return;
        }
        const { plyr } = player;
        plyr.muted = true;
        plyr.play();
    }, []);

    return (
        <>
            <Box className={styles.videoContainer}>
                <Plyr
                    options={VIDEO_OPTIONS}
                    ref={handleAutoPlay}
                    source={VIDEO_SOURCE}
                />
            </Box>

            <Text fw={500} fz={16} mt={23} ta="center">
                Watch this 60-second instructional video. Learn how to get
                started and earn your first $10,000 commission.
            </Text>
            <Button
                className={styles.startButton}
                mt="xl"
                radius="xl"
                size="md"
                onClick={handleNext}
            >
                Get Started
            </Button>
        </>
    );
};

export default Onboarding;
